import { state, addMessage, setState, INKO_STATES } from "./state.js";

export function initChat(root) {
    const form = root.querySelector("#inko-chat-form");

    const input = root.querySelector("#inko-prompt");

    const messages = root.querySelector("#inko-messages");

    const sendButton = root.querySelector("#inko-send-button");

    const messageUrl = root.dataset.messageUrl;

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        const text = input.value.trim();

        if (!text) {
            return;
        }

        input.value = "";

        appendMessage(messages, "user", text);

        addMessage({
            role: "user",
            content: text,
        });

        setState({
            status: INKO_STATES.THINKING,
        });

        sendButton.disabled = true;

        try {
            const response = await fetch(messageUrl, {
                method: "POST",

                headers: {
                    "Content-Type": "application/json",

                    Accept: "application/json",

                    "X-CSRF-TOKEN": root.dataset.csrf,
                },

                credentials: "same-origin",

                body: JSON.stringify({
                    conversation_id: state.conversationId,

                    message: text,
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Terjadi kesalahan.");
            }

            handleResponse(result, messages);
        } catch (error) {
            appendMessage(
                messages,
                "assistant",
                error.message || "Maaf, INKO sedang mengalami gangguan.",
            );

            setState({
                status: INKO_STATES.FAILED,
            });
        } finally {
            sendButton.disabled = false;
            input.focus();
        }
    });

    root.querySelectorAll("[data-suggestion]").forEach((button) => {
        button.addEventListener("click", () => {
            input.value = button.dataset.suggestion;

            input.focus();
        });
    });
}

function handleResponse(result, messages) {
    const data = result.data || {};

    if (data.conversation_id) {
        setState({
            conversationId: data.conversation_id,
        });
    }

    if (data.design_id) {
        setState({
            designId: data.design_id,
        });
    }

    if (data.type === "clarification") {
        setState({
            status: INKO_STATES.CLARIFYING,
        });
    }

    if (data.type === "asset_confirmation") {
        setState({
            status: INKO_STATES.WAITING_ASSET,
        });
    }

    if (data.type === "ready_to_generate") {
        setState({
            status: INKO_STATES.PLANNING,
        });

        window.dispatchEvent(
            new CustomEvent("inko:ready-to-generate", {
                detail: data,
            }),
        );
    }

    appendMessage(
        messages,
        "assistant",
        result.message || data.message || "INKO selesai memproses.",
    );

    addMessage({
        role: "assistant",
        content: result.message || data.message || "",
        metadata: data,
    });
}

function appendMessage(container, role, content) {
    const element = document.createElement("div");

    element.className = `inko-message inko-message-${role}`;

    const bubble = document.createElement("div");

    bubble.className = "inko-message-bubble";

    bubble.textContent = content;

    element.appendChild(bubble);

    container.appendChild(element);

    container.scrollTop = container.scrollHeight;
}
